(() => {
  function enhance(host) {
    if (host.dataset.ggZoomAnywhere === 'true') return;
    const stage = host.querySelector('.gg-live-stage');
    const zoomButton = host.querySelector('.gg-live-zoom');
    const thumbnails = host.querySelector('.gg-gallery-thumbs');
    if (!stage || !zoomButton) return;

    host.dataset.ggZoomAnywhere = 'true';
    const cursor = document.createElement('span');
    cursor.className = 'gg-gallery-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.textContent = '+';
    stage.append(cursor);

    let startX = 0;
    let startY = 0;
    let suppressClickUntil = 0;
    const keepActiveThumbnailVisible = () => {
      if (!thumbnails || getComputedStyle(thumbnails).flexDirection !== 'row') return;
      const active = thumbnails.querySelector('button[aria-pressed="true"]');
      if (!active) return;
      const strip = thumbnails.getBoundingClientRect();
      const thumb = active.getBoundingClientRect();
      if (thumb.left < strip.left) thumbnails.scrollBy({ left: thumb.left - strip.left - 4, behavior: 'smooth' });
      if (thumb.right > strip.right) thumbnails.scrollBy({ left: thumb.right - strip.right + 4, behavior: 'smooth' });
    };

    const moveCursor = event => {
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      if (event.target.closest('.gg-gallery-prev, .gg-gallery-next, .gg-live-zoom')) {
        cursor.classList.remove('is-visible');
        return;
      }
      const bounds = stage.getBoundingClientRect();
      cursor.style.left = `${Math.min(Math.max(event.clientX - bounds.left, 21), bounds.width - 21)}px`;
      cursor.style.top = `${Math.min(Math.max(event.clientY - bounds.top, 21), bounds.height - 21)}px`;
      cursor.classList.add('is-visible');
    };

    stage.addEventListener('pointerenter', moveCursor);
    stage.addEventListener('pointermove', moveCursor);
    stage.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'));

    stage.addEventListener('touchstart', event => {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });

    stage.addEventListener('touchend', event => {
      const touch = event.changedTouches[0];
      if (Math.hypot(touch.clientX - startX, touch.clientY - startY) > 12) {
        suppressClickUntil = Date.now() + 400;
        requestAnimationFrame(keepActiveThumbnailVisible);
      }
    }, { passive: true });

    stage.addEventListener('click', event => {
      if (event.target.closest('.gg-gallery-prev, .gg-gallery-next, .gg-live-zoom')) return;
      if (Date.now() < suppressClickUntil) return;
      cursor.classList.remove('is-visible');
      zoomButton.click();
    });

    host.addEventListener('click', event => {
      if (event.target.closest('.gg-gallery-prev, .gg-gallery-next, .gg-gallery-thumbs button')) {
        requestAnimationFrame(keepActiveThumbnailVisible);
      }
    });
  }

  const scan = () => document.querySelectorAll('.gg-live-preview').forEach(enhance);
  scan();
  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
